/* Product Tabs — tab switching + per-panel scroll-snap slider mirroring the
   Trending slider exactly: integer slidesPerView (CSS --spv ladder),
   group-based dots (one dot per group of spv cards), edge-riding hover
   arrows stepping one card per click. Vanilla JS, multi-instance,
   Shopify theme-editor aware. No dependencies, no autoplay. */
(function () {
  'use strict';

  function ProductTabs(root) {
    if (!root || root.__ntProdTabsInit) return;
    root.__ntProdTabsInit = true;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.nt-prodtabs__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.nt-prodtabs__panel'));
    var viewall = root.querySelector('.nt-prodtabs__viewall');

    function Panel(panel) {
      if (panel.__bound) { panel.__refresh(); return; }
      panel.__bound = true;

      var track = panel.querySelector('.nt-prodtabs__track');
      var prev = panel.querySelector('.nt-prodtabs__arrow--prev');
      var next = panel.querySelector('.nt-prodtabs__arrow--next');
      var dotsWrap = panel.querySelector('.nt-prodtabs__dots');
      var dots = [];
      if (!track) { panel.__refresh = function () {}; return; }

      function cards() { return track.querySelectorAll('.nt-prodtabs__card'); }
      function maxScroll() { return track.scrollWidth - track.clientWidth; }

      function pitch() {
        var cs = cards();
        if (cs.length > 1) {
          var p = cs[1].offsetLeft - cs[0].offsetLeft;
          if (p > 1) return p;
        }
        return cs.length ? cs[0].offsetWidth + 16 : 300;
      }

      function spv() {
        var v = parseFloat(getComputedStyle(track).getPropertyValue('--spv'));
        return v > 0 ? Math.round(v) : 1;
      }

      function pageCount() {
        return Math.max(1, Math.ceil(cards().length / spv()));
      }

      function currentPage() {
        var max = maxScroll();
        if (max <= 1) return 0;
        if (track.scrollLeft >= max - 2) return pageCount() - 1;
        var leftmost = Math.round(track.scrollLeft / pitch());
        return Math.min(pageCount() - 1, Math.round(leftmost / spv()));
      }

      function updateArrows() {
        var max = maxScroll();
        var scrollable = max > 1;
        var x = track.scrollLeft;
        if (prev) prev.disabled = !scrollable || x <= 2;
        if (next) next.disabled = !scrollable || x >= max - 2;
      }

      function syncDots() {
        var i = currentPage();
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }

      function buildDots() {
        if (!dotsWrap) return;
        var n = pageCount();
        var scrollable = maxScroll() > 1;
        dotsWrap.innerHTML = '';
        dots = [];
        dotsWrap.style.display = (!scrollable || n < 2) ? 'none' : '';
        if (!scrollable || n < 2) return;
        for (var p = 0; p < n; p++) {
          (function (group) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'nt-prodtabs__dot';
            b.setAttribute('aria-label', 'Go to card group ' + (group + 1));
            b.addEventListener('click', function () {
              track.scrollTo({ left: Math.min(group * spv() * pitch(), maxScroll()), behavior: 'smooth' });
            });
            dotsWrap.appendChild(b);
            dots.push(b);
          })(p);
        }
        syncDots();
      }

      var raf;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; updateArrows(); syncDots(); });
      }, { passive: true });

      function step(dir) {
        track.scrollBy({ left: dir * pitch(), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { if (!prev.disabled) step(-1); });
      if (next) next.addEventListener('click', function () { if (!next.disabled) step(1); });

      panel.__refresh = function () { updateArrows(); buildDots(); };
      panel.__refresh();
    }

    function activate(panelId) {
      var activeTab = null;
      var activePanel = null;

      tabs.forEach(function (t) {
        var on = t.getAttribute('data-panel') === panelId;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) activeTab = t;
      });

      panels.forEach(function (p) {
        var on = p.id === panelId;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); activePanel = p; }
        else { p.setAttribute('hidden', ''); }
      });

      if (viewall && activeTab) {
        var url = activeTab.getAttribute('data-viewall');
        if (url) { viewall.setAttribute('href', url); viewall.classList.remove('is-hidden'); }
        else { viewall.classList.add('is-hidden'); }
      }

      // Panel is now visible, so its track is measurable.
      if (activePanel) Panel(activePanel);
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-panel')); });
    });

    var initial = root.querySelector('.nt-prodtabs__panel.is-active') || panels[0];
    if (initial) Panel(initial);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        if (!root.isConnected) return;
        var vis = root.querySelector('.nt-prodtabs__panel.is-active');
        if (vis && vis.__refresh) vis.__refresh();
      }, 150);
    });

    root.__prodtabsActivate = activate;
  }

  function initAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var roots = container.querySelectorAll('.nt-prodtabs');
    Array.prototype.forEach.call(roots, ProductTabs);
    if (container.classList && container.classList.contains('nt-prodtabs')) ProductTabs(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target || !e.target.closest) return;
    var root = e.target.closest('.nt-prodtabs');
    if (!root || !root.__prodtabsActivate) return;
    var tab = e.target.closest('.nt-prodtabs__tab');
    if (tab) root.__prodtabsActivate(tab.getAttribute('data-panel'));
  });
})();
